
import React from 'react';
import { connect } from 'react-redux';
import camelCase from 'lodash/camelCase';

import { topLevelPageId } from '../../util/topLevelPage';

// Shared "which top level section is open" slot. Kept out of redux on purpose:
// the pages slice is persisted to localStorage, so an open/closed nav state
// would outlive a reload when it has no business doing so.
export const NavAccordionContext = React.createContext({
  openSectionId: null,
  toggleSection: () => {},
  openSection: () => {}
});

// Topmost ancestor of the page being read, or null when nothing is selected.
// That is the one section allowed to start open.
const topLevelSectionId = (pages) => {
  const allPages = pages.pages ? pages.pages : {};
  const sluggedPage = pages.sluggedPages && pages.currentPage ? pages.sluggedPages[camelCase(pages.currentPage)] : false;
  return topLevelPageId(allPages, sluggedPage) || null;
}

class _NavAccordion extends React.Component {

  constructor(props) {
    super(props);
    this.state = {openSectionId: props.defaultSectionId, touched: false};
    this.toggleSection = this.toggleSection.bind(this);
    this.openSection = this.openSection.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    // Keep following the default until the reader expands something themselves,
    // so a late Firestore snapshot still opens the section holding the current page.
    if (!state.touched && state.openSectionId !== props.defaultSectionId) {
      return {openSectionId: props.defaultSectionId};
    }
    return null;
  }

  toggleSection(id) {
    this.setState(state => ({
      touched: true,
      openSectionId: state.openSectionId === id ? null : id
    }));
  }

  // Opening is not the same as toggling: following a link must never collapse the
  // section you just navigated to, and it has to work even after the reader has
  // collapsed something by hand, which is what stops the derived-state default.
  openSection(id) {
    this.setState({touched: true, openSectionId: id});
  }

  render() {
    const {openSectionId} = this.state;
    return (
      <NavAccordionContext.Provider value={{openSectionId: openSectionId, toggleSection: this.toggleSection, openSection: this.openSection}}>
        {this.props.children}
      </NavAccordionContext.Provider>
    )
  }
}

const mapStateToProps = ({pages}) => {
  return {
      defaultSectionId: topLevelSectionId(pages)
  }
}

export const NavAccordion = connect(mapStateToProps)(_NavAccordion)

export default NavAccordion
